<template>
  <sui-card class="state-card">
    <sui-card-content class="compact">
      <b>Project</b>
    </sui-card-content>
    <router-link class="content link" :to="url" title="Go to project" data-goal="SERVICE_PAGE_PROJECT_OPEN">
      <i class="folder huge yellow fitted icon" />
      <b>{{project.name}}</b>
    </router-link>
    <sui-dimmer :active="isMoved" inverted  @click="isMoved = null">
      <p><i class="check inverted teal large circular fitted icon" /></p>
      <p>The service has been moved to <b>{{project.name}}</b> project.</p>
    </sui-dimmer>
    <sui-button-group class="fluid" size="mini" attached="bottom">
      <sui-button :disabled="isMoveDisabled" @click="$refs.dropdown.handleClick($event)">Change...</sui-button>
      <sui-dropdown ref="dropdown" class="icon" :class="{disabled: isMoveDisabled}" button icon="dropdown">
        <sui-dropdown-menu>
          <sui-dropdown-item icon="arrow right" v-for="project in otherProjects" :key="project.id" :disabled="!actionsById[project.id].projectUsage" data-goal="SERVICE_PAGE_PROJECT_MOVE" @click="moveService(project.id)">
            <i class="folder yellow fitted icon" /><b style="margin-left: .5em;">{{project.name}}</b>
          </sui-dropdown-item>
        </sui-dropdown-menu>
      </sui-dropdown>
    </sui-button-group>
  </sui-card>
</template>

<script>
  import {mapGetters} from 'vuex'

  export default {
    name: 'ServiceProjectCard',
    props: {
      service: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        isMoved: false,
      }
    },
    computed: {
      ...mapGetters(['actionsById', 'projects', 'projectsById']),
      actions() {
        return this.actionsById[this.service.id]
      },
      project() {
        return this.service._project
      },
      url() {
        return this.project ? this.project._path : '/'
      },
      otherProjects() {
        return this.projects.filter(project => project.id !== this.service.project)
      },
      isMoveDisabled() {
        const hasMoveMethod = this.service.constructor.methods.move
        const hasOtherProjects = Boolean(this.otherProjects.length)
        return this.service._inProgress || !hasMoveMethod || !hasOtherProjects || !this.actions.serviceChangeProject
      },
    },
    sockets: {
      update(data) {
        if (data.target === 'service' && data.id === this.service.id) {
          if (data.project) {
            this.isMoved = true
            setTimeout(() => {
              this.isMoved = false
            }, 2000)
          }
        }
      },
    },
    methods: {
      moveService(projectId) {
        const serviceName = this.service.name
        const oldProjectName = this.project.name
        const newProjectName = this.projectsById[projectId].name
        return this.$modals.confirm.open({
          text: `Service <b>${serviceName}</b> will be moved<br>from project <b>${oldProjectName}</b> to project <b>${newProjectName}</b>`,
          callback: () => {
            this.service.move(projectId).catch(error => {
              this.$emit('error', error.message)
            })
          },
        })
      },
    },
  }
</script>

<style media="screen">
  .link { white-space: normal; }
</style>
